var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogowhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1052px",
    height: "384px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefefe",
    d: "M 244.5,116.5 C 243.437,120.639 242.77,124.972 242.5,129.5C 241.855,140.957 240.355,152.29 238,163.5C 237.439,164.022 236.772,164.355 236,164.5C 204.175,161.446 172.342,158.446 140.5,155.5C 139.612,152.946 139.279,150.279 139.5,147.5C 141.145,142.766 141.811,137.766 141.5,132.5C 141.951,127.763 142.618,123.097 143.5,118.5C 145.145,113.766 145.811,108.766 145.5,103.5C 146.45,92.6803 148.284,82.0136 151,71.5C 157.811,59.1769 168.311,53.8435 182.5,55.5C 195.847,56.4558 209.181,57.6225 222.5,59C 239.298,61.4614 247.965,71.1281 248.5,88C 247.847,97.7339 246.514,107.234 244.5,116.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fdf4f1",
    d: "M 145.5,103.5 C 145.811,108.766 145.145,113.766 143.5,118.5C 143.741,113.306 144.407,108.306 145.5,103.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fdf5f1",
    d: "M 244.5,116.5 C 244.844,121.122 244.177,125.455 242.5,129.5C 242.77,124.972 243.437,120.639 244.5,116.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefefe",
    d: "M 306.5,148.5 C 306.5,150.5 307.5,151.5 309.5,151.5C 311.167,152.5 312.5,153.833 313.5,155.5C 314.08,157.749 315.413,159.415 317.5,160.5C 322.661,164.828 326.328,170.161 328.5,176.5C 328.427,178.027 329.094,179.027 330.5,179.5C 333.296,184.105 335.296,189.105 336.5,194.5C 336.054,197.01 336.72,199.01 338.5,200.5C 341.1,214.606 341.1,228.606 338.5,242.5C 337.076,244.515 336.41,246.848 336.5,249.5C 335.99,252.539 335.323,255.539 334.5,258.5C 332.824,259.183 332.157,260.517 332.5,262.5C 315.337,300.646 286.004,322.979 244.5,329.5C 233.146,329.66 221.813,329.326 210.5,328.5C 192.851,326.338 177.517,319.338 164.5,307.5C 164.027,306.094 163.027,305.427 161.5,305.5C 143.225,289.289 132.559,268.956 129.5,244.5C 129.5,241.5 129.5,238.5 129.5,235.5C 131.167,235.5 132.833,235.5 134.5,235.5C 147.406,237.547 160.073,240.214 172.5,243.5C 172.054,246.01 172.72,248.01 174.5,249.5C 179.404,263.748 188.404,274.748 201.5,282.5C 202.3,284.741 203.966,285.741 206.5,285.5C 229.637,294.274 251.304,291.607 271.5,277.5C 274.5,276.5 276.5,274.5 277.5,271.5C 280.5,270.5 282.5,268.5 283.5,265.5C 289.769,255.71 294.102,245.044 296.5,233.5C 298.019,230.474 298.685,227.141 298.5,223.5C 298.497,220.975 298.163,218.641 297.5,216.5C 296.137,212.368 295.137,208.035 294.5,203.5C 294.771,201.62 294.104,200.287 292.5,199.5C 288.145,191.97 282.812,185.136 276.5,179C 268.437,174.636 260.103,170.802 251.5,167.5C 250.702,167.043 250.369,166.376 250.5,165.5C 251.388,162.946 251.721,160.279 251.5,157.5C 251.585,150.565 252.585,143.899 254.5,137.5C 255.795,133.733 256.461,129.733 256.5,125.5C 257.946,124.387 259.613,124.22 261.5,125C 278.538,129.183 293.538,137.017 306.5,148.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fdf4f1",
    d: "M 256.5,125.5 C 256.461,129.733 255.795,133.733 254.5,137.5C 254.344,133.236 255.011,129.236 256.5,125.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fdf4f1",
    d: "M 141.5,132.5 C 141.811,137.766 141.145,142.766 139.5,147.5C 139.741,142.306 140.407,137.306 141.5,132.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefefe",
    d: "M 377.5,139.5 C 390.526,139.334 403.526,139.834 416.5,141C 418.815,142.109 420.315,143.943 421,146.5C 421.478,151.868 421.145,157.201 420,162.5C 416.666,181.835 413.333,201.168 410,220.5C 409.333,225.833 409.333,231.167 410,236.5C 414.747,248.208 423.247,252.041 435.5,248C 445.429,242.003 451.262,233.169 453,221.5C 456.667,198.833 460.333,176.167 464,153.5C 465.161,146.654 468.994,142.154 475.5,140C 486.5,139.333 497.5,139.333 508.5,140C 513.837,142.654 516.17,146.987 515.5,153C 512.272,176.871 508.772,200.704 505,224.5C 491.137,282.532 454.637,306.699 395.5,297C 374.33,291.497 361.83,277.997 358,256.5C 356.61,248.542 356.277,240.542 357,232.5C 360.961,204.109 365.294,175.775 370,147.5C 371.38,143.625 373.88,140.958 377.5,139.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefefe",
    d: "M 541.5,139.5 C 574.168,139.333 606.835,139.5 639.5,140C 650.058,144.489 652.225,151.656 646,161.5C 629,185.5 612,209.5 595,233.5C 592.834,236.333 591.334,239.5 590.5,243C 591.154,244.987 592.487,246.32 594.5,247C 606.833,247.333 619.167,247.667 631.5,248C 637.699,249.363 640.699,253.196 640.5,259.5C 642.334,275.485 635.334,283.985 619.5,285C 586.833,285.667 554.167,285.667 521.5,285C 515.586,285.716 511.586,283.383 509.5,278C 510.809,273.366 512.976,269.199 516,265.5C 536.719,238.449 557.052,211.115 577,183.5C 578.544,179.188 577.044,177.022 572.5,177C 559.5,176.667 546.5,176.333 533.5,176C 529.633,174.14 527.3,171.14 526.5,167C 527.714,160.886 528.881,154.72 530,148.5C 532.732,143.907 536.565,140.907 541.5,139.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefefe",
    d: "M 680.5,139.5 C 713.502,139.333 746.502,139.5 779.5,140C 790.058,144.489 792.225,151.656 786,161.5C 766.498,187.845 747.998,214.845 730.5,242.5C 730.931,244.766 732.264,246.266 734.5,247C 746.833,247.333 759.167,247.667 771.5,248C 777.699,249.363 780.699,253.196 780.5,259.5C 782.33,275.489 775.33,283.989 759.5,285C 726.833,285.667 694.167,285.667 661.5,285C 651.044,285.246 647.877,280.746 652,271.5C 672.423,243.655 693.09,215.988 714,188.5C 716.958,185.616 717.792,182.283 716.5,178.5C 715.271,177.719 713.938,177.219 712.5,177C 699.5,176.667 686.5,176.333 673.5,176C 669.658,174.159 667.324,171.159 666.5,167C 667.72,160.848 668.886,154.682 670,148.5C 672.489,144.168 675.989,141.168 680.5,139.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefefe",
    d: "M 854.5,141.5 C 876.836,141.333 899.169,141.5 921.5,142C 923.899,142.731 926.065,143.898 928,145.5C 929.263,152.728 929.93,160.061 930,167.5C 931.095,205.166 931.762,242.833 932,280.5C 931.691,281.766 931.191,282.933 930.5,284C 915.568,285.617 900.568,285.951 885.5,285C 884.667,284.167 883.833,283.333 883,282.5C 882.831,274.812 882.331,267.145 881.5,259.5C 870.88,258.357 860.214,258.19 849.5,259C 846.278,266.664 843.445,274.497 841,282.5C 840.5,283.667 839.667,284.5 838.5,285C 823.455,285.817 808.455,285.65 793.5,284.5C 792.186,279.676 792.686,275.009 795,270.5C 810.47,229.755 826.137,189.088 842,148.5C 845.272,144.371 849.439,142.038 854.5,141.5 Z M 880.5,167.5 C 881.832,176.642 882.498,186.142 882.5,196C 882.333,205.5 882.167,215 882,224.5C 876.25,225.641 870.416,225.807 864.5,225C 862.675,223.534 862.175,221.701 863,219.5C 868.742,202.106 874.576,184.773 880.5,167.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fcf6f4",
    d: "M 139.5,147.5 C 139.279,150.279 139.612,152.946 140.5,155.5C 139.252,154.666 138.585,153.333 138.5,151.5C 138.511,149.955 138.844,148.622 139.5,147.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fef3ef",
    d: "M 306.5,148.5 C 307.833,149.167 308.833,150.167 309.5,151.5C 307.5,151.5 306.5,150.5 306.5,148.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fef4f0",
    d: "M 313.5,155.5 C 315.587,156.585 316.92,158.251 317.5,160.5C 315.413,159.415 314.08,157.749 313.5,155.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fdf3ef",
    d: "M 251.5,157.5 C 251.721,160.279 251.388,162.946 250.5,165.5C 249.957,165.44 249.624,165.107 249.5,164.5C 250.067,162.018 250.734,159.684 251.5,157.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefefd",
    d: "M 159.5,168.5 C 159.611,169.117 159.944,169.617 160.5,170C 164.821,170.499 169.154,170.666 173.5,170.5C 190.909,170.982 208.242,172.315 225.5,174.5C 230.944,175.884 236.611,176.55 242.5,176.5C 249.271,176.535 253.938,179.535 256.5,185.5C 256.54,188.881 256.207,192.214 255.5,195.5C 251.741,198.374 247.407,200.208 242.5,201C 223.116,203.936 203.783,207.102 184.5,210.5C 182.535,210.948 182.202,211.948 183.5,213.5C 185.409,214.348 187.409,214.682 189.5,214.5C 199.255,217.517 200.921,223.017 194.5,231C 173.269,231.929 152.603,228.929 132.5,222C 125.749,219.663 123.416,215.163 125.5,208.5C 128.089,207.581 130.089,205.914 131.5,203.5C 134.546,200.643 138.213,198.81 142.5,198C 152.121,196.089 161.787,194.422 171.5,193C 173.888,192.697 176.055,191.863 178,190.5C 178.271,188.193 177.105,187.026 174.5,187C 160.986,186.59 147.652,184.924 134.5,182C 131.606,179.091 130.773,175.591 132,171.5C 133.579,169.959 135.413,168.792 137.5,168C 144.844,167.548 152.177,167.715 159.5,168.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fcf3ef",
    d: "M 159.5,168.5 C 164.305,169.06 168.971,169.727 173.5,170.5C 169.154,170.666 164.821,170.499 160.5,170C 159.944,169.617 159.611,169.117 159.5,168.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fcf1ed",
    d: "M 225.5,174.5 C 231.389,174.45 237.056,175.116 242.5,176.5C 236.611,176.55 230.944,175.884 225.5,174.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fef3f0",
    d: "M 328.5,176.5 C 329.906,176.973 330.573,177.973 330.5,179.5C 329.094,179.027 328.427,178.027 328.5,176.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fdf2ee",
    d: "M 256.5,185.5 C 257.156,186.622 257.489,187.955 257.5,189.5C 257.639,191.883 256.972,193.883 255.5,195.5C 256.207,192.214 256.54,188.881 256.5,185.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fef4f1",
    d: "M 336.5,194.5 C 337.458,196.302 338.125,198.302 338.5,200.5C 336.72,199.01 336.054,197.01 336.5,194.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fdf0ed",
    d: "M 292.5,199.5 C 294.104,200.287 294.771,201.62 294.5,203.5C 293.326,202.486 292.66,201.153 292.5,199.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fef6f3",
    d: "M 131.5,203.5 C 130.089,205.914 128.089,207.581 125.5,208.5C 126.911,206.086 128.911,204.419 131.5,203.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fef4f1",
    d: "M 184.5,210.5 C 184.414,211.496 184.748,212.329 185.5,213C 187.058,213.21 188.391,213.71 189.5,214.5C 187.409,214.682 185.409,214.348 183.5,213.5C 182.202,211.948 182.535,210.948 184.5,210.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fcf4f2",
    d: "M 297.5,216.5 C 298.163,218.641 298.497,220.975 298.5,223.5C 298.685,227.141 298.019,230.474 296.5,233.5C 297.292,227.87 297.625,222.203 297.5,216.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fef5f2",
    d: "M 134.5,235.5 C 132.833,235.5 131.167,235.5 129.5,235.5C 129.5,238.5 129.5,241.5 129.5,244.5C 128.521,241.375 128.187,238.042 128.5,234.5C 130.735,234.205 132.735,234.539 134.5,235.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fef5f2",
    d: "M 172.5,243.5 C 173.458,245.302 174.125,247.302 174.5,249.5C 172.72,248.01 172.054,246.01 172.5,243.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fef5f2",
    d: "M 338.5,242.5 C 338.59,245.152 337.924,247.485 336.5,249.5C 336.41,246.848 337.076,244.515 338.5,242.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fdf2ee",
    d: "M 334.5,258.5 C 334.011,259.995 333.345,261.329 332.5,262.5C 332.157,260.517 332.824,259.183 334.5,258.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fdf4f0",
    d: "M 283.5,265.5 C 282.5,268.5 280.5,270.5 277.5,271.5C 279.167,269.167 281.167,267.167 283.5,265.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fcf3ef",
    d: "M 277.5,271.5 C 276.5,274.5 274.5,276.5 271.5,277.5C 273.167,275.167 275.167,273.167 277.5,271.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fdf2ef",
    d: "M 201.5,282.5 C 203.368,283.263 205.035,284.263 206.5,285.5C 203.966,285.741 202.3,284.741 201.5,282.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fdf3f0",
    d: "M 161.5,305.5 C 163.027,305.427 164.027,306.094 164.5,307.5C 162.973,307.573 161.973,306.906 161.5,305.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fdf3ef",
    d: "M 210.5,328.5 C 221.813,329.326 233.146,329.66 244.5,329.5C 240.012,330.166 235.346,330.499 230.5,330.5C 223.596,330.692 216.93,330.025 210.5,328.5 Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogowhite);
export default __webpack_public_path__ + "static/media/logowhite.87ce14230eaefe540ce36e62d7c59516.svg";
export { ForwardRef as ReactComponent };